import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth5getGetScreenTruthAppsAppChromeRequirementsResponseSchema = jsonObject
export type tcpscreentruth5getGetScreenTruthAppsAppChromeRequirementsResponse = z.infer<typeof tcpscreentruth5getGetScreenTruthAppsAppChromeRequirementsResponseSchema>
